import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import * as Types from '../../../../types/api.types.generated.d';

const defaultOptions = {} as const;
export type NotificationsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type NotificationsQuery = {
  __typename?: 'Query';
  expertNotifications: {
    __typename?: 'ExpertNotificationsQueryResultType';
    notifications: Array<{
      __typename?: 'ExpertNotificationType';
      id: string;
      type: Types.ExpertNotificationTypeEnum;
      metadata?: string | null;
      createdAt: any;
      viewedAt?: any | null;
      relatesTo: {
        __typename?: 'ExpertNotificationRelationsType';
        jobOrderId?: string | null;
        jobOrderApplicationId?: string | null;
      };
    }>;
  };
};

export const NotificationsDocument = gql`
  query notifications {
    expertNotifications {
      notifications {
        id
        type
        relatesTo {
          jobOrderId
          jobOrderApplicationId
        }
        metadata
        createdAt
        viewedAt
      }
    }
  }
`;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsQuery(
  baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(
    NotificationsDocument,
    options,
  );
}
export function useNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(
    NotificationsDocument,
    options,
  );
}
export function useNotificationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<NotificationsQuery, NotificationsQueryVariables>(
    NotificationsDocument,
    options,
  );
}
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsSuspenseQueryHookResult = ReturnType<typeof useNotificationsSuspenseQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<
  NotificationsQuery,
  NotificationsQueryVariables
>;
export function refetchNotificationsQuery(variables?: NotificationsQueryVariables) {
  return { query: NotificationsDocument, variables };
}
